import commonJsModule from "html-favicon-webpack-plugin"

export default commonJsModule.default